import { Card, CardActionArea } from '@mui/material';
import { Link as ReactRouterLink, useRouteMatch } from 'react-router-dom';

import { type api } from 'common';

import { FlowTemplateCardContent } from './Card/Content';
import { FLOW_TEMPLATE_CARD_HEIGHT_IN_PIXELS } from './constants';
import { EventAction, EventCategory, useCaptureEvents } from '../../../../utils/events/index';

interface FlowTemplateCardWithLinkProps {
  flowTemplate: Pick<
    api.FlowDefinitionTemplate.FlowDefinitionTemplate,
    'id' | 'name' | 'tags' | 'content' | 'organizationId'
  >;
}

export function FlowTemplateCardWithLink(props: FlowTemplateCardWithLinkProps) {
  const { flowTemplate } = props;

  const { id, name } = flowTemplate;

  const match = useRouteMatch();
  const { captureEvent } = useCaptureEvents();

  return (
    <Card
      sx={{
        height: FLOW_TEMPLATE_CARD_HEIGHT_IN_PIXELS,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 2,
      }}
      variant="outlined"
    >
      <CardActionArea
        component={ReactRouterLink}
        to={`${match.url}/${id}`}
        onClick={() => {
          captureEvent({
            category: EventCategory.FlowDefinitionTemplate,
            action: EventAction.CardClick,
            properties: {
              templateId: id,
              templateName: name,
            },
          });
        }}
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'start',
          alignItems: 'start',
        }}
      >
        <FlowTemplateCardContent flowTemplate={flowTemplate} />
      </CardActionArea>
    </Card>
  );
}
